
$(function () {
    if ($(".vid_player").length) {
        setTimeout(() => {
            $('.main-wrapper .player').hide()
        }, 14000);
    }
    
    $('.btn-open-agoda').click(() => $('.pop-agoda').show())
    $('.main-img').hover(() => $('.main-weather').toggleClass('on'))
});
    